// extracted by mini-css-extract-plugin
export default {"wrapper":"Section_wrapper__D45ko","content_wrapper":"Section_content_wrapper__dHDik","inner_wrapper":"Section_inner_wrapper__scPmk"};